{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
        151.15591425157967,-33.68834372000069
        ]
      },
      "properties": {
        "name": "Sphinx Walk"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
        150.29059,-33.70371
        ]
      },
      "properties": {
        "name": "Six foot track"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            150.3120553998699, -33.73196775624329
        ]
      },
      "properties": {
        "name": "Katoomba",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
        74.57950579031711, 42.51248314829303
        ]
      },
      "properties": {
        "name": "KG",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            80.17411914133028, 42.213405765504476
        ]
      },
      "properties": {
        "name": "Khan Tengri",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            131.03388514743847, -25.34584297139171
        ]
      },
      "properties": {
        "name": "Uluru",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            -151.00726915968875,63.069268194834244
        ]
      },
      "properties": {
        "name": "Mt Denali",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            80.129257551509, 42.03767896555761
        ]
      },
      "properties": {
        "name": "Pik Pobedy",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            86.9251465845193, 27.98955908635046
        ]
      },
      "properties": {
        "name": "Mt Everest",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            22.35011553189942, 40.08838447876729
        ]
      },
      "properties": {
        "name": "Mt Olympus",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            37.35554126906301,-3.065881717083569
        ]
      },
      "properties": {
        "name": "Mt Kilimanjaro",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            -77.5800702637765,-9.169719296932207
        ]
      },
      "properties": {
        "name": "Cordillera Blanca",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            -112.09523569822798,36.10031704536186
        ]
      },
      "properties": {
        "name": "Grand Canyon",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            -157.80960937978762,21.26148763859345
        ]
      },
      "properties": {
        "name": "Oahu Hawaii",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            138.73121113691982,35.363529199406074
        ]
      },
      "properties": {
        "name": "Mt Fuji",
        "zoom": 14
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
            142.592522558379, 11.393434778584895
        ]
      },
      "properties": {
        "name": "Challenger Deep",
        "zoom": 14
      }
    }
  ]
}
